import { motion } from 'framer-motion';
import { Users } from '../icons';
import type { TeamCompletion } from '../../lib/partner-dashboard';

interface TeamCompletionSummaryProps {
  teams: TeamCompletion[];
  locale?: string;
}

export function TeamCompletionSummary({ teams, locale }: TeamCompletionSummaryProps) {
  const tr = locale === 'tr';
  if (teams.length === 0) {
    return (
      <div className="freud-card-elevated p-6">
        <h3 className="text-text-xl text-gray-80 mb-4">{tr ? 'Takim Tamamlama' : 'Team Completion'}</h3>
        <p className="text-text-sm text-gray-40 text-center py-6">
          {tr ? 'Henuz takim olusturulmadi' : 'No teams created yet'}
        </p>
      </div>
    );
  }

  return (
    <div className="freud-card-elevated p-6">
      <h3 className="text-text-xl text-gray-80 mb-4">{tr ? 'Takim Tamamlama' : 'Team Completion'}</h3>
      <div className="space-y-3">
        {teams.map((team, index) => {
          const barColor = team.rate >= 80
            ? 'bg-success-40'
            : team.rate >= 50
            ? 'bg-orange-40'
            : 'bg-destructive-40';

          return (
            <motion.div
              key={team.teamId}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
            >
              <div className="flex items-center justify-between mb-1.5">
                <div className="flex items-center gap-2 min-w-0">
                  <Users className="w-4 h-4 text-gray-40 flex-shrink-0" />
                  <span className="text-text-sm text-gray-80 font-medium truncate">
                    {team.teamName}
                  </span>
                </div>
                <span className="text-text-xs text-gray-50 flex-shrink-0 ml-2">
                  {team.completedMembers}/{team.totalMembers}
                </span>
              </div>
              <div className="w-full bg-brand-10 rounded-full h-2">
                <motion.div
                  className={`${barColor} h-2 rounded-full`}
                  initial={{ width: 0 }}
                  animate={{ width: team.totalMembers > 0 ? `${team.rate}%` : '0%' }}
                  transition={{ duration: 0.6, delay: index * 0.05 }}
                />
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
